import React, { useState, useEffect, useCallback } from "react";
import { TextField, Button, TableRow, TableCell, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSystemId } from "../../../hooks/useReduxSelectors";
import { sendCommand } from "../../../ducks/uiDuck";
import { useDispatch } from "react-redux";

const PIDRow = ({ row, handleOnChange, inputSelected }) => {
  const [point, setPoint] = useState("");
  const systemId = useSystemId();
  const [autoTune, setAutoTune] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation("common");

  const handleChange = useCallback(
    (value, rowName, field) => {
      setPoint(value);
      handleOnChange(value, rowName, field);
    },
    [handleOnChange]
  );

  const autoTunePidContollersButton = () => {
    if (!autoTune) {
      setAutoTune(true);
      dispatch(sendCommand({
        argsProps: {
          HwId: "SYSTEM_IO",
          Command: "RetunePID",
          Value: row.name,
        },
        commandType: "Qal3",
        systemId,
      }));
    } else {
      setAutoTune(false);
    }
  };

  useEffect(() => {
    if (autoTune) {
      const timeout = setTimeout(() => setAutoTune(false), 2000);
      return () => clearTimeout(timeout);
    }
  }, [autoTune]);

  useEffect(() => {
    if (row) setPoint(row.setpoint ?? "");
  }, [row]);

  return (
    <TableRow>
      <TableCell>{row.name}</TableCell>
      <TableCell align="center">
        <TextField
          size="small"
          value={point}
          onChange={(e) => handleChange(e.target.value, row.name, "setpoint")}
          onClick={(e) => inputSelected(e, row.name)}
          error={point !== "" && point != null && isNaN(Number(String(point).replace(",", ".")))}
          helperText={point !== "" && point != null && isNaN(Number(String(point).replace(",", "."))) ? "Input a number" : ""}
          sx={{ width: 100 }}
        />
      </TableCell>
      <TableCell align="center">
        {row.autotuneDone ? "Done" : "Not Done"}
      </TableCell>
      <TableCell align="center">
        <Button disabled={autoTune} size="medium" onClick={() => autoTunePidContollersButton()} color={autoTune ? "error" : "primary"}>
          {t("Autotune")}
          {autoTune && (<CircularProgress size={16} sx={{ ml: 0.5 }} />)}
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default PIDRow;
